import promotions from "./events/promotion";
import { passiveLabour } from "./actions";

const labour = {
  label: "Labour",
  levels: [
    {
      name: "Amateur",
      minExperience: 0,
      actionLabel: "Work",
      description: "hard work, for scant reward",
      bonus: 0.0,
      onLevelUp: null,
      randomEvents: [],
      storyArc: null,
    },
    {
      name: "Scavenger",
      minExperience: 10,
      actionLabel: "Work",
      description: "scavenging for scraps.",
      bonus: 0.0,
      onLevelUp: null,
      randomEvents: [],
      storyArc: null,
    },
    {
      name: "Ranch Hand",
      minExperience: 25,
      actionLabel: "Work",
      description: "back breaking work, but it's honest",
      bonus: 0.07,
      onLevelUp: (context, setEvent) =>
        promotions(context, setEvent).find((p) =>
          p.title.includes("Ranch Hand")
        ),
      randomEvents: [],
      storyArc: null,
    },

    // Was Night Herder, "protecting livestock from nocturnal threats", which no player could
    // ever have done: work is gated to daylight (`!calendar.isNight()` in actions/city/work),
    // because the day/night split is what makes rob the night verb and work the day one. The
    // promotion event was never nocturnal anyway — it is a gap in the fence spotted on a
    // routine check — so the job is renamed to the man who rides the edges and finds it.
    {
      name: "Outrider",
      minExperience: 45,
      actionLabel: "Work",
      description: "riding the edges of the herd, watching for strays and breaks",
      bonus: 0.07,
      onLevelUp: (context, setEvent) =>
        promotions(context, setEvent).find((p) => p.title.includes("Outrider")),
      randomEvents: [],
      storyArc: null,
    },
    // Day Herder had nothing left to be the day half of. `find` matches on the localized title,
    // so this substring must stay unique across the promotion titles — Outrider above is the
    // only other herding rank and does not contain it.
    {
      name: "Herder",
      minExperience: 70,
      actionLabel: "Work",
      description: "guiding the herd through pastures and dangers alike",
      bonus: 0.1,
      onLevelUp: (context, setEvent) =>
        promotions(context, setEvent).find((p) => p.title.includes("Herder")),
      dailyBenefits: [passiveLabour(0.1)],
      randomEvents: [],
      storyArc: null,
    },
    {
      name: "Horse Wrangler",
      minExperience: 100,
      actionLabel: "Work",
      description: "caring for and training the ranch's horses",
      bonus: 0.14,
      onLevelUp: (context, setEvent) =>
        promotions(context, setEvent).find((p) =>
          p.title.includes("Horse Wrangler")
        ),
      dailyBenefits: [passiveLabour(0.2)],
      randomEvents: [],
      storyArc: null,
    },
    {
      name: "Fence Rider",
      minExperience: 135,
      actionLabel: "Work",
      description: "maintaining and securing ranch boundaries",
      bonus: 0.2,
      onLevelUp: (context, setEvent) =>
        promotions(context, setEvent).find((p) =>
          p.title.includes("Fence Rider")
        ),
      randomEvents: [],
      dailyBenefits: [passiveLabour(0.3)],
      storyArc: null,
    },
    {
      name: "Chuck Wrangler",
      minExperience: 170,
      actionLabel: "Work",
      description: "supporting the cook, ensuring the crew is well-fed",
      bonus: 0.28,
      onLevelUp: (context, setEvent) =>
        promotions(context, setEvent).find((p) =>
          p.title.includes("Chuck Wrangler")
        ),
      randomEvents: [],
      dailyBenefits: [passiveLabour(0.4)],
      storyArc: null,
    },
    {
      name: "Brander Assistant",
      minExperience: 220,
      actionLabel: "Work",
      description: "assisting in the crucial task of livestock branding",
      bonus: 0.4,
      onLevelUp: (context, setEvent) =>
        promotions(context, setEvent).find((p) =>
          p.title.includes("Brander Assistant")
        ),
      randomEvents: [],
      dailyBenefits: [passiveLabour(0.5)],
      storyArc: null,
    },
    {
      name: "Trail Hand",
      minExperience: 270,
      actionLabel: "Work",
      description: "overseeing cattle drives, ensuring safety and efficiency",
      bonus: 0.56,
      onLevelUp: (context, setEvent) =>
        promotions(context, setEvent).find((p) =>
          p.title.includes("Trail Hand")
        ),
      randomEvents: [],
      dailyBenefits: [passiveLabour(0.5)],
      storyArc: null,
    },
    {
      name: "Foreman",
      minExperience: 320,
      actionLabel: "Work",
      description: "commanding the operations of the ranch",
      bonus: 0.78,
      onLevelUp: (context, setEvent) =>
        promotions(context, setEvent).find((p) => p.title.includes("Foreman")),
      randomEvents: [],
      dailyBenefits: [passiveLabour(1.5)],
      storyArc: null,
    },
  ],
  traitMultipliers: {
    resilience: 0.03,
    // Ingenuity: 0.05, // Example for future trait
  },
};

export default labour;
